// ═══════════════════════════════════════════════════════════════════════════
// Utilidades de interfaz
// Extraído VERBATIM de index.html v0.9.16.
// ═══════════════════════════════════════════════════════════════════════════



export const generateId = () => "id_" + Date.now() + "_" + Math.random().toString(36).substr(2, 5);

export const IS_MOBILE = /Android|iPhone|iPad|iPod|webOS/i.test(navigator.userAgent);

// `permiso` deja fuera la pestaña a quien no puede usarla. Ocultar no es
// seguridad —el control real está en la RLS— pero una pestaña que solo sabe
// decir "no puedes" es peor que no estar.
export const TABS = [
  { id: "invoices", label: "Nueva Remisión", icon: "📋" },
  // ── Una lista con lentes, para quien vende ──────────────────────────────
  //
  // Historial y Cuentas se quedan, pero NO para el vendedor: para él eran dos
  // ordenamientos de lo mismo y ninguna contestaba su pregunta —"¿ya se timbró,
  // ya se pagó, cuándo cobro?"— porque los tres estados vivían repartidos.
  //
  // Decisión del operador: "Cuentas e historial no desaparecen de la barra. El
  // dueño o administrador pueden ver eso. La vista fusionada es para los
  // vendedores." Quien administra cruza clientes y persigue cobranza; quien
  // vende necesita su lista.
  { id: "ventas", label: "Mis ventas", icon: "🧾", permiso: "ver_mis_ventas" },
  { id: "history", label: "Historial", icon: "📁", permiso: "ver_estadisticas" },
  { id: "accounts", label: "Cuentas", icon: "📊", permiso: "ver_estadisticas" },
  { id: "clients", label: "Clientes", icon: "👥" },
  // Al vendedor no le aparece: si no puede editar nada, la pestaña solo repite
  // lo que ya ve al levantar la remisión —precio del cliente y existencias—
  // sin dejarle tocar. "Es inoperante", dijo el operador, y lo es.
  { id: "products", label: "Productos", icon: "🍷", permiso: "ver_catalogo" },
  // Bodegas va junto a Productos y no junto a Config: es operación diaria
  // —dónde está el vino, qué salió, qué va en camino— y no un ajuste que se
  // toca una vez.
  { id: "bodegas", label: "Bodegas", icon: "🏬", permiso: "administrar_bodegas" },
  { id: "team", label: "Vendedores", icon: "🤝", permiso: "asignar_cartera" },
  { id: "me", label: "Mi cuenta", icon: "👤", permiso: "editar_mi_perfil" },
  { id: "settings", label: "Config", icon: "⚙️", permiso: "ver_configuracion" },
  // La pestaña del superusuario de PLATAFORMA. No lleva `permiso` porque no es
  // un permiso de vinícola: no cuelga de la membresía ni de un rol. Se decide
  // aparte, con `es_super_admin()`, y por eso `tabsPara` la excluye siempre y
  // App la agrega cuando corresponde.
  { id: "plataforma", label: "Plataforma", icon: "🌐", soloPlataforma: true },
];

/** Las pestañas que este rol puede usar. */
export const tabsPara = (puedeFn, esPlataforma = false) =>
  TABS.filter(t => (t.soloPlataforma ? esPlataforma : (!t.permiso || puedeFn(t.permiso))));

/**
 * La pestaña que DE VERDAD se muestra.
 *
 * Quitar el botón de Config de la barra no bastaba: a `settings` se llega
 * también desde los distintivos del encabezado y desde los enlaces "ir a
 * Config" del Historial, de Cuentas y de Clientes. Cualquiera de esos metía al
 * vendedor a la pantalla de llaves de Facturapi, datos del remitente, folio y
 * respaldos, que no es suya.
 *
 * Por eso se resuelve aquí, en el único punto por el que pasa todo, y no
 * puerta por puerta: las puertas se olvidan, y la que se olvide la siguiente
 * vez ya queda cerrada.
 *
 * Sigue siendo INTERFAZ, no seguridad — igual que el resto de `permisos.js`.
 * Lo que impide de verdad está en la RLS.
 */
export const tabPermitida = (id, puedeFn, esPlataforma = false) => {
  const t = TABS.find(x => x.id === id);
  if (!t) return "invoices";
  // Una pestaña de plataforma no se decide por permiso de vinícola: se decide
  // por `es_super_admin()`. Si esto no lo supiera, la barra la escondería y el
  // ruteo la dibujaría — la incoherencia exacta que esta función existe para
  // evitar, y que atrapó la prueba al agregarla.
  if (t.soloPlataforma) return esPlataforma ? t.id : "invoices";
  return (!t.permiso || puedeFn(t.permiso)) ? t.id : "invoices";
};
